<template>
  <ul>
    <Coupon as="li" v-for="i of list" :key="i.cname" :i="i" @click="receive(i)"
      :isGet="i.received || receivedList.includes(i.cid)"
    >{{i.cname}}</Coupon>
  </ul>
  <LargeCoupon :i="item" v-show="isShow" @close="close"/>
</template>

<script>
import { useRoute } from 'vue-router'
import axios from '@/use/useAxios'
import useTime from '@/use/useTime'
import { onMounted, reactive, ref } from 'vue'
import Coupon from '@/components/Coupon'
// import ShowMsg from '@/components/ShowMsg'
// import showMsg, { msg } from '@/use/useShowMsg'
import LargeCoupon from '@/components/LargeCoupon'

export default {
  name: 'List',
  components: { Coupon, LargeCoupon },
  setup () {
    const route = useRoute()
    const list = reactive([])
    const item = reactive({})
    const receivedList = reactive([])
    const isShow = ref(false)
    const phone = route.params.phone
    const code = route.params.code
    const timeFormat = '{y}-{m}-{d}'
    const status = ['未开始', '进行中', '已结束']
    const types = {
      culture: '文化沙龙',
      theme: '主题讲座',
      study: '研学活动',
      display: '会展活动',
      perform: '演出活动'
    }

    const receive = i => {
      Object.entries(i).forEach(([k, v]) => { item[k] = v })
      isShow.value = true
    }

    const close = _ => { isShow.value = false }

    onMounted(_ => {
      axios.get('/active/activelist', {
        params: { phone, code }
      }).then(d => d.data.data.forEach((i, j) => {
        i.startTime = useTime(i.startTime, timeFormat)
        i.endTime = useTime(i.endTime, timeFormat)
        i.activeStatus = status[i.activeStatus - 1]
        i.activeType = types[i.activeType]
        list[j] = i
      })).catch(e => console.log(e))

      axios.get('/offline/receivedcoupons', { params: { phone } }).then(d => {
        d.data.data.forEach((i, j) => { receivedList[j] = i.cid })
      })
    })
    return {
      list,
      receive,
      receivedList,
      item,
      isShow,
      close
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  margin: 5% auto;
  @for $i from 1 through 10 { &:nth-child(#{$i}) { animation: animate 1s #{$i}00ms backwards } }
}

@keyframes animate {
  from { opacity: 0 }
  to { opacity: 1 }
}
</style>
